"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.black = void 0;
var _styledComponents = require("styled-components");
var _index = _interopRequireWildcard(require("../../components/LexusButton/index.styled"));
var _index2 = _interopRequireDefault(require("./index.styled"));
const black = exports.black = (0, _styledComponents.css)`
    background: #000;
    color: #fff;
  ${_index2.default.DrawerHeading} {
    color: ${function (_ref) {
  let {
    labelColor
  } = _ref;
  return labelColor || "#fff";
}};
  }
  ${_index2.default.Arrow} {
    fill: #fff;
  }
`;
const white = exports.white = (0, _styledComponents.css)`
    background: #fff;
    color: #000;
  ${_index2.default.DrawerHeading} {
    color: ${function (_ref2) {
  let {
    labelColor
  } = _ref2;
  return labelColor || "#000";
}};
  }
  ${_index2.default.Arrow} {
    fill: #000;
  }
`;